/**
 * @class BlockAnnouncement
 * @classdesc Class for handling theme editor interactions
 */
export default class BlockAnnouncement extends Core.BlockComponent {
  constructor(el, context) {
    super(el, context);
  }

  onSelect() {
    const selectEvent = new CustomEvent('announcement-block:select', { detail: { index: this.el.dataset.slideIndex }, bubbles: true });
    this.el.dispatchEvent(selectEvent);
  }

  onDeselect() {
    const deselectEvent = new CustomEvent('announcement-block:deselect', { bubbles: true });
    this.el.dispatchEvent(deselectEvent);
  }
}
